import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Class representing the view for registered documents table.
 * @extends JetView
 */
export default class tableRegisteredDocumentView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        var vthis = this; // Reference to the current instance
        const cur_user = this.getParam('user', true); // Get current user parameter

        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            id: 'datatable', // Unique ID for the DataTable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                // Column definitions
                                {
                                    id: 'Id',
                                    header: 'ID',
                                    width: 100,
                                    sort: 'int', // Sort by integer
                                },
                                {
                                    id: 'Name',
                                    header: _('Nombre'), // Localized header
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'Route',
                                    header: _('Ruta'),
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'Version',
                                    header: _('Versión'),
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'Type',
                                    header: _('Tipo'),
                                    width: 150,
                                    sort: 'int',
                                },
                                { id: 'Date', header: _('Fecha'), width: 250 },
                                {
                                    id: 'EncryptionValue',
                                    header: _('Encriptación'),
                                    width: 250,
                                    sort: 'int',
                                },
                                {
                                    id: 'IsActivate',
                                    header: _('Estado'),
                                    options: [
                                        // Options for the IsActivate column
                                        { id: 'A', value: _('Activo') },
                                        { id: 'I', value: _('Inactivo') },
                                    ],
                                    width: 150,
                                    sort: 'int',
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    // Event handler for edit button click
                                    vthis.app.callEvent('openEdit', [{}]);
                                },
                            },
                            ready: function () {
                                // Event handler for when the DataTable is ready
                                if (!this.count()) {
                                    // Check if there are no rows
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Fetch data configuration
                            pager: 'pagerA', // Pager ID
                            on: {
                                onItemDblClick: (id) => {
                                    // Event handler for double-click on item
                                    $$('EditDocument').show();
                                },
                                onBeforeLoad: function () {
                                    // Event before loading data
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                onAfterLoad: function () {
                                    // Event after loading data
                                    this.hideOverlay();
                                },
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The DataTable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        grid = $$('datatable'); // Reference to the DataTable instance
        const cur_user = this.getParam('user', true); // Get current user parameter
        var url = devConfig.geturlApi() + 'es/RegisteredDocument/GetDocuments?PlayerId=' + cur_user + '&'; // API URL for fetching documents
        var filter = ''; // Filter string for API requests

        // Event listener for filtering documents
        this.on(this.app, 'registeredDocument:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', '');
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&PlayerId=' + cur_user; // Append current user to filter
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });

        var datePopup = []; // Array to hold document types for popup
        var popupAdd = ''; // Variable for the add document popup

        // AJAX request to fetch document types
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'RegisteredDocument/TypeDocument', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message on failure
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse response
                    if (!resp.HasError) {
                        // Check for errors in response
                        datePopup = resp.Data; // Store document types
                        popupAdd = webix.ui({
                            // Create add document popup
                            view: 'window',
                            id: 'AddDocument',
                            head: {
                                view: 'toolbar',
                                cols: [
                                    {
                                        view: 'label',
                                        label: _('Añadir Documento'), // Localized label
                                    },
                                    {
                                        view: 'icon',
                                        icon: 'wxi-close',
                                        click: function () {
                                            this.getTopParentView().hide(); // Close popup
                                        },
                                    },
                                ],
                            },
                            position: 'center',
                            modal: true,
                            body: {
                                view: 'form',
                                id: 'addform', // ID for the form
                                elements: [
                                    // Form elements
                                    {
                                        view: 'text',
                                        label: _('Nombre'),
                                        name: 'Name',
                                        required: true, // Required field
                                    },
                                    {
                                        view: 'text',
                                        label: _('Ruta'),
                                        name: 'Route',
                                        required: true,
                                    },
                                    {
                                        view: 'text',
                                        label: _('Versión'),
                                        name: 'Version',
                                        required: true,
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Tipo'),
                                        name: 'Type',
                                        options: datePopup, // Options from fetched document types
                                        required: true,
                                    },
                                    {
                                        view: 'combo',
                                        label: _('Estado'),
                                        name: 'IsActivate',
                                        options: [
                                            {
                                                id: 'A',
                                                value: _('Activado'), // Localized value
                                            },
                                            {
                                                id: 'I',
                                                value: _('Inactivado'),
                                            },
                                        ],
                                        required: true,
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: 'Cancelar',
                                                click: function () {
                                                    this.getTopParentView().hide(); // Close popup
                                                    $$('addform').setValues(
                                                        $$('addform').getCleanValues(), // Clear form values
                                                    );
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form',
                                                value: 'Guardar',
                                                click: function ($e) {
                                                    var values = $$('addform').getValues(); // Get form values
                                                    if (
                                                        $$('addform').validate() // Validate form
                                                    ) {
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() +
                                                                    'RegisteredDocument/AddDocument',
                                                                '{"Name":"' +
                                                                    values.Name +
                                                                    '", "Route":"' +
                                                                    values.Route +
                                                                    '", "Version":"' +
                                                                    values.Version +
                                                                    '", "Type":"' +
                                                                    values.Type +
                                                                    '","IsActivate":"' +
                                                                    values.IsActivate +
                                                                    '"}',
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message('Error! '); // Error message on failure
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var resp = JSON.parse(text); // Parse response
                                                                        if (resp.HasError) {
                                                                            webix.message({
                                                                                title: _('¡Error!'),
                                                                                type: 'alert-error',
                                                                                text: _(
                                                                                    'Ocurrio un error, comuniquese con soporte',
                                                                                ),
                                                                            }); // Error message
                                                                        } else {
                                                                            webix.message(
                                                                                'Documento Agregado', // Success message
                                                                            );
                                                                            grid.clearAll(); // Clear grid data
                                                                            grid.load(
                                                                                url +
                                                                                    '?start=0&count=' +
                                                                                    grid.data.$pagesize +
                                                                                    filter, // Reload grid data
                                                                            );
                                                                        }
                                                                    },
                                                                },
                                                            );
                                                        $$('addform').setValues(
                                                            $$('addform').getCleanValues(), // Clear form values
                                                        );
                                                        this.getTopParentView().hide(); // Close popup
                                                    } else {
                                                        webix.message({
                                                            title: _('¡Error!'),
                                                            type: 'alert-error',
                                                            text: _(
                                                                'Completa los campos...', // Validation error message
                                                            ),
                                                        });
                                                    }
                                                },
                                            },
                                        ],
                                    },
                                ],
                                elementsConfig: {
                                    on: {
                                        onChange: function () {
                                            this.validate(); // Validate form on change
                                        },
                                    },
                                },
                            },
                        });
                    }
                },
            });

        // Event handler for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event handler for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id);
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event handler for before edit starts
        grid.attachEvent('onBeforeEditStart', function (id) {
            var item = this.getItem(id);
            console.log(item);
            if (id.column == 'Action') {
                var options = this.getColumnConfig('Action').collection;
                if (item.IsRegisterActivate != 'I') {
                    // Check if item is inactive
                    console.log(item);
                    return false; // Prevent editing
                }
                console.log(id);
            }
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });

        var popup = webix.ui({
            // Create edit document popup
            view: 'window',
            id: 'EditDocument',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Documento') }, // Localized label
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            position: 'center',
            modal: true,
            body: {
                view: 'form',
                id: 'editForm', // ID for the edit form
                elements: [
                    { view: 'text', label: 'ID', name: 'Id', readonly: true }, // Read-only ID field
                    { view: 'text', label: _('Nombre'), name: 'Name' },
                    { view: 'text', label: _('Ruta'), name: 'Route' },
                    { view: 'text', label: _('Versión'), name: 'Version' },
                    {
                        view: 'combo',
                        label: _('Tipo'),
                        name: 'Type',
                        options: [
                            { id: '1', value: _('Documento 1') },
                            { id: '2', value: _('Documento 2') },
                        ],
                    },
                    { name: 'Date', header: _('Fecha'), width: 250 },
                    {
                        view: 'combo',
                        label: _('Estado'),
                        name: 'IsActivate',
                        options: [
                            { id: 'A', value: _('Activado') },
                            { id: 'I', value: _('Inactivado') },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'),
                                click: function () {
                                    this.getTopParentView().hide(); // Close popup
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Clear form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'),
                                click: function ($e) {
                                    var values = $$('editForm').getValues(); // Get form values
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'RegisteredDocument/UpdateDocument',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "Name":"' +
                                                values.Name +
                                                '", "Route":"' +
                                                values.Route +
                                                '", "Version":"' +
                                                values.Version +
                                                '", "Type":"' +
                                                values.Type +
                                                '","IsActivate":"' +
                                                values.IsActivate +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message on failure
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(
                                                        'Documento Actualizado', // Success message
                                                    );
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                    );
                                                },
                                            },
                                        );
                                    $$('editForm').setValues(
                                        $$('editForm').getCleanValues(), // Clear form values
                                    );
                                    this.getTopParentView().hide(); // Close popup
                                },
                            },
                        ],
                    },
                ],
            },
        });

        $$('editForm').bind($$('datatable')); // Bind edit form to DataTable

        // Event listener for add document button
        this.on(this.app, 'addDocument:button', (filter) => {
            if (datePopup.length > 0) {
                // Check if document types are loaded
                $$('addform').clearValidation(); // Clear validation
                popupAdd.show(); // Show add document popup
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });

        // Event listener for opening edit document popup
        this.on(this.app, 'openEdit', (filterData) => {
            popup.show(); // Show edit document popup
        });
    }
}

// FILE DOCUMENTED
